<div
    *ngIf="searchModel"
    class="agpr-recommendedSearchSummary"
>
    @if(isQuickEditResponse) {
        <agpr-message
            id="agpr_recommendedSearchSummary_isQuickEdit"
            class="agpr-recommendedSearchSummary-isQuickEdit"
            [severity]="messageSeverityEnum.info"
        >
            <span [innerHTML]="'Discover.recommendedSearchSummary.isQuickEdit.banner.message' | localize"></span>
            <agpr-button
                label="Discover.recommendedSearchSummary.isQuickEdit.banner.link"
                [ariaDescribedBy]="'agpr_recommendedSearchSummary_isQuickEdit'"
                (click)="resetSearch()"
                [style]="buttonTypes.link"
            ></agpr-button>
        </agpr-message>

        <agpr-targeting-search-summary
            [targetingSearch]="searchModel"
        ></agpr-targeting-search-summary>
    } @else {
        <div class="agpr-recommendedSearchSummary-copilot">
            <div class="agpr-recommendedSearchSummary-copilot-icon">
                <i class="fa-kit-duotone fa-agpr-ai-contacts"></i>
            </div>

            <div class="agpr-recommendedSearchSummary-copilot-text">
                {{ 'Discover.recommendedSearchSummary.agilityAgent.analyzed' | localize }}
            </div>
        </div>

        <div class="agpr-recommendedSearchSummary-section">
            <label class="agpr-recommendedSearchSummary-title">
                <i class="agpr-recommendedSearchSummary-title-icon fa-regular fa-duotone fa-location-dot"></i>
                {{ 'Discover.recommendedSearchSummary.prCoPilot.regionalRelevance' | localize }}
            </label>

            <div class="agpr-recommendedSearchSummary-subSection">
                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.areasOfCoverage">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.targetAudienceRegion' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary
                            [(ngModel)]="searchModel.areasOfCoverage"
                            labelLookupValue="displayString"
                            labelLookupKey="collectionId"
                            [labelLookup]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)">
                        </agpr-filter-summary>
                    </div>
                </ng-container>

                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.mediaMarkets">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.mediaMarkets' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary
                            [(ngModel)]="searchModel.mediaMarkets"
                            labelLookupValue="displayString"
                            labelLookupKey="id"
                            [labelLookup]="journodexEnumsService.getMediaMarketsByIds.bind(journodexEnumsService)">
                        </agpr-filter-summary>
                    </div>
                </ng-container>

                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.coverageFocuses">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.coverageFocuses' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary
                            [(ngModel)]="searchModel.coverageFocuses"
                            labelLookupValue="displayString"
                            labelLookupKey="enumValue"
                            [labelLookup]="journodexEnumsService.getCoverageFocuses()">
                        </agpr-filter-summary>
                    </div>
                </ng-container>

                <ng-container *ngIf="!searchIncludeExcludeNotEmpty?.areasOfCoverage && !searchIncludeExcludeNotEmpty?.mediaMarkets && !searchIncludeExcludeNotEmpty?.coverageFocuses">
                    <div class="agpr-recommendedSearchSummary-details">
                        {{ 'Discover.recommendedSearchSummary.prCoPilot.regionalRelevanceNotRelevant' | localize }}
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="agpr-recommendedSearchSummary-section">
            <label class="agpr-recommendedSearchSummary-title">
                <i class="agpr-recommendedSearchSummary-title-icon fa-regular fa-duotone fa-bullseye-arrow"></i>
                {{ 'Discover.recommendedSearchSummary.prCoPilot.contentFocus' | localize }}
            </label>

            <div class="agpr-recommendedSearchSummary-subSection">
                <!-- subject -->
                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.subjects">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.subjects' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary
                            [(ngModel)]="searchModel.subjects"
                            labelLookupValue="name"
                            labelLookupKey="id"
                            [labelLookup]="journodexSubjectsService.getChildrenByIds.bind(journodexSubjectsService)">
                        </agpr-filter-summary>
                    </div>
                </ng-container>

                <!-- keywords -->
                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.outletMonitoringKeywords">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.keywords' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary [(ngModel)]="searchModel.outletMonitoringKeywords"></agpr-filter-summary>
                    </div>
                </ng-container>

                <ng-container *ngIf="!searchIncludeExcludeNotEmpty?.outletMonitoringKeywords && !searchIncludeExcludeNotEmpty?.subjects">
                    <div class="agpr-recommendedSearchSummary-details">
                        {{ 'Discover.recommendedSearchSummary.prCoPilot.contentFocusNotRelevant' | localize }}
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="agpr-recommendedSearchSummary-section">
            <label class="agpr-recommendedSearchSummary-title">
                <i class="agpr-recommendedSearchSummary-title-icon fa-regular fa-duotone fa-users-viewfinder"></i>
                {{ 'Discover.recommendedSearchSummary.prCoPilot.audienceRelevance' | localize }}
            </label>

            <div class="agpr-recommendedSearchSummary-subSection">
                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.marketSectors">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.marketSectors' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary
                            [(ngModel)]="searchModel.marketSectors"
                            labelLookupValue="displayString"
                            labelLookupKey="enumValue"
                            [labelLookup]="journodexEnumsService.getMarketSectors()">
                        </agpr-filter-summary>
                    </div>
                </ng-container>

                <ng-container *ngIf="searchIncludeExcludeNotEmpty?.targetAudiences">
                    <label class="agpr-recommendedSearchSummary-label">
                        {{ 'Discover.targeting.searchFieldLabels.targetAudiences' | localize }}
                    </label>
                    <div class="agpr-recommendedSearchSummary-details">
                        <agpr-filter-summary
                            [(ngModel)]="searchModel.targetAudiences"
                            labelLookupValue="displayString"
                            labelLookupKey="enumValue"
                            [labelLookup]="journodexEnumsService.getTargetAudiences()">
                        </agpr-filter-summary>
                    </div>
                </ng-container>

                <ng-container *ngIf="!searchIncludeExcludeNotEmpty?.marketSectors && !searchIncludeExcludeNotEmpty?.targetAudiences">
                    <div class="agpr-recommendedSearchSummary-details">
                        {{ 'Discover.recommendedSearchSummary.prCoPilot.audienceRelevanceNotRelevant' | localize }}
                    </div>
                </ng-container>
            </div>
        </div>
    }
</div>
